module.exports = __webpack_public_path__ + "img/smartphone_photo_satsuei_man.104f8251.png";